export const extractFormID = (url: string) => {
  return url
    .replace('admin', '')
    .replace('form', '')
    .replace('preview', '')
    .replace(new RegExp('/', 'g'), '')
}
